(function () {
  if (window.whBrindes) return;
  window.whBrindes = true;

  var cfg = { regras: [] };
  try {
    var el = document.getElementById('wh-brindes-config');
    if (el) cfg = JSON.parse(el.textContent);
  } catch (e) {}
  var regras = cfg.regras || [];

  var nativo = window.fetch.bind(window);
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var STATUS = 'https://api.dooki.com.br/v2/public/shopify/status?shop=' + window.location.host;
  var yampi = null;
  var reserva = null;
  var temBrindes = false;

  var CAMPANHA = 'wh_campanha';
  try {
    var utm = new URLSearchParams(window.location.search).get('utm_campaign');
    if (utm) localStorage.setItem(CAMPANHA, JSON.stringify({ c: utm.toLowerCase(), t: Date.now() }));
  } catch (e) {}

  function cupom() {
    if (!cfg.cupom) return null;
    try {
      var m = JSON.parse(localStorage.getItem(CAMPANHA) || 'null');
      if (m && m.c === cfg.cupom.campanha && Date.now() - m.t < 2592000000) return cfg.cupom.codigo;
    } catch (e) {}
    return null;
  }

  if (typeof window.ymp_getUrlWithUtms === 'function') {
    var montarUrl = window.ymp_getUrlWithUtms;
    window.ymp_getUrlWithUtms = function (url) {
      var final = montarUrl(url);
      var codigo = cupom();
      if (!codigo || !final) return final;
      try {
        var u = new URL(final);
        u.searchParams.set('promocode', codigo);
        return u.href;
      } catch (e) { return final; }
    };
  }

  function consultarYampi() {
    return Promise.race([
      nativo(STATUS)
        .then(function (r) { return r.json(); })
        .then(function (d) { return !!(d && d.data && d.data.active); }),
      new Promise(function (ok) { setTimeout(function () { ok(false); }, 4000); })
    ])
      .catch(function () { return false; })
      .then(function (ativa) { yampi = ativa; return ativa; });
  }

  function pedir(url, corpo) {
    var op = { headers: { Accept: 'application/json' } };
    if (corpo) {
      op.method = 'POST';
      op.headers['Content-Type'] = 'application/json';
      op.body = JSON.stringify(corpo);
    }
    return nativo(raiz + url, op).then(function (r) { return r.json(); });
  }

  function ehBrinde(item) {
    return !!(item.properties && item.properties._wh_brinde);
  }

  function sincronizar(ativa) {
    return pedir('cart.js').then(function (cart) {
      var pagos = {};
      var brindes = {};
      cart.items.forEach(function (it) {
        if (ehBrinde(it)) {
          var r = it.properties._wh_brinde;
          (brindes[r] = brindes[r] || []).push(it);
        } else {
          pagos[it.product_id] = (pagos[it.product_id] || 0) + it.quantity;
        }
      });

      var mudar = [];
      var incluir = [];
      regras.forEach(function (r) {
        var linhas = brindes[r.id] || [];
        delete brindes[r.id];
        var direito = ativa && (pagos[r.gatilho] || 0) >= r.min;
        var mantida = false;
        linhas.forEach(function (it) {
          if (direito && !mantida && it.variant_id === r.brinde) {
            mantida = true;
            if (it.quantity !== 1) mudar.push({ id: it.key, quantity: 1 });
          } else {
            mudar.push({ id: it.key, quantity: 0 });
          }
        });
        if (direito && !mantida) {
          incluir.push({ id: r.brinde, quantity: 1, properties: { _wh_brinde: r.id } });
        }
      });
      Object.keys(brindes).forEach(function (k) {
        brindes[k].forEach(function (it) { mudar.push({ id: it.key, quantity: 0 }); });
      });

      if (!mudar.length && !incluir.length) return cart;

      var passo = Promise.resolve();
      mudar.forEach(function (m) {
        passo = passo.then(function () { return pedir('cart/change.js', m); });
      });
      if (incluir.length) {
        passo = passo.then(function () { return pedir('cart/add.js', { items: incluir }); });
      }
      return passo
        .then(function () { return pedir('cart.js'); })
        .then(function (novo) { novo.whMudou = true; return novo; });
    });
  }

  function contar(cart) {
    temBrindes = cart.items.some(ehBrinde);
    var n = 0;
    cart.items.forEach(function (it) { if (!ehBrinde(it)) n += it.quantity; });
    document.querySelectorAll('.cart-count').forEach(function (c) {
      c.textContent = c.classList.contains('cart-count-drawer') ? '(' + n + ')' : String(n);
    });
  }

  function destravar(raizEl) {
    raizEl.querySelectorAll('img').forEach(function (img) {
      img.loading = 'eager';
      function pronto() {
        var caixa = img.closest('.bls-loading-image');
        if (caixa) caixa.classList.remove('bls-loading-image');
        img.classList.add('loaded', 'lazyloaded');
      }
      if (img.complete && img.naturalWidth > 0) pronto();
      else {
        img.addEventListener('load', pronto, { once: true });
        img.addEventListener('error', pronto, { once: true });
      }
    });
  }

  function redesenhar() {
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return Promise.resolve();
    }
    var atual = document.querySelector('#form-mini-cart');
    if (!atual) return Promise.resolve();
    return nativo(window.location.pathname + '?section_id=form-mini-cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('#form-mini-cart');
        if (novo) {
          atual.innerHTML = novo.innerHTML;
          destravar(atual);
        }
      });
  }

  var timer = null;
  function agendar() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      (yampi === null ? consultarYampi() : Promise.resolve(yampi))
        .then(sincronizar)
        .then(function (cart) {
          return (cart.whMudou ? redesenhar() : Promise.resolve()).then(function () { contar(cart); });
        })
        .catch(function () {});
    }, 350);
  }

  window.fetch = function (entrada, opcoes) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    var resposta = nativo(entrada, opcoes);
    if (/\/cart\/(add|change|update|clear)/.test(url)) resposta.then(agendar, agendar);
    return resposta;
  };

  function irShopify() {
    return sincronizar(false)
      .catch(function () {})
      .then(function () {
        var codigo = cupom();
        window.location.href = codigo
          ? raiz + 'discount/' + encodeURIComponent(codigo) + '?redirect=' + encodeURIComponent(raiz + 'checkout')
          : raiz + 'checkout';
      });
  }

  document.addEventListener('click', function (e) {
    var botao = e.target.closest && e.target.closest('.bls-btn-checkout[onclick*="yampiClick"]');
    if (!botao) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (botao.disabled || botao.getAttribute('aria-busy') === 'true') return;
    botao.setAttribute('aria-busy', 'true');
    consultarYampi().then(function (ativa) {
      if (!ativa || typeof window.yampiClick !== 'function') return irShopify();
      return sincronizar(true)
        .catch(function () {})
        .then(function () {
          window.yampiClick();
          reserva = setTimeout(irShopify, 15000);
        });
    });
  }, true);

  document.addEventListener('submit', function (e) {
    var quem = e.submitter;
    var form = e.target;
    if (!quem || quem.name !== 'checkout' || !temBrindes || form.dataset.whLiberado) return;
    e.preventDefault();
    sincronizar(false)
      .catch(function () {})
      .then(function () {
        temBrindes = false;
        form.dataset.whLiberado = '1';
        if (form.requestSubmit) form.requestSubmit(quem);
        else window.location.href = raiz + 'checkout';
      });
  }, true);

  if (document.getElementById('main-cart-items')) {
    setTimeout(function () {
      var tela = document.querySelector('.yampi-loader');
      if (tela && tela.style.display === 'block') tela.style.display = 'none';
    }, 8000);
  }

  window.addEventListener('pagehide', function () { clearTimeout(reserva); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('.bls-btn-checkout[aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
    agendar();
  });

  consultarYampi().then(agendar);
})();
